export const SESSION_REPORT_TIMEOUT_MESSAGE = '조회할 기록이 많아 시간이 초과됐어요. 강사를 골라 다시 조회해 주세요.';
/** 503 SESSION_REPORT_TOO_MANY_UNASSIGNED(서버 f1194f6e) — 서버 문구 대신 이 문구를 쓴다. */
export const SESSION_REPORT_TOO_MANY_ERROR_CODE = 'SESSION_REPORT_TOO_MANY_UNASSIGNED';
export const SESSION_REPORT_TOO_MANY_MESSAGE = '기록이 많아 한 번에 불러오지 못했어요. 강사를 골라 다시 조회해 주세요';

/**
 * 503 SESSION_REPORT_TIMEOUT · SESSION_REPORT_TOO_MANY_UNASSIGNED. 둘 다 「강사를 지정해 다시 조회」 상태라 같은 오류로 다룬다
 * (화면은 강사 고르기, 엑셀은 파일을 만들지 않음). errorCode 로 둘을 가른다. 결과(data)로 돌려주지 않고 오류로 던진다 —
 * 데이터로 두면 React Query 가 5분간 「성공」으로 캐시해 다시 받아도 요청이 안 나간다.
 * 오류 상태는 다시 마운트·다시 시도 때 실제로 재요청된다.
 */
export class SessionReportTimeoutError extends Error {
    readonly status = 503;
    readonly errorCode: 'SESSION_REPORT_TIMEOUT' | typeof SESSION_REPORT_TOO_MANY_ERROR_CODE;
    constructor(message?: string, errorCode: 'SESSION_REPORT_TIMEOUT' | typeof SESSION_REPORT_TOO_MANY_ERROR_CODE = 'SESSION_REPORT_TIMEOUT') {
        super(
            errorCode === SESSION_REPORT_TOO_MANY_ERROR_CODE ? SESSION_REPORT_TOO_MANY_MESSAGE : message || SESSION_REPORT_TIMEOUT_MESSAGE,
        );
        this.errorCode = errorCode;
        this.name = 'SessionReportTimeoutError';
    }
}

export const isSessionReportTimeout = (error: unknown): error is SessionReportTimeoutError =>
    error instanceof SessionReportTimeoutError;

/** 엑셀 수집 실패 사유 이름. 「기록이 많음」은 TOO_MANY_UNASSIGNED. */
export const SESSION_REPORT_TOO_MANY_REASON = '기록이 많음';
export const sessionReportFailureReason = (error: unknown) =>
    isSessionReportTimeout(error)
        ? error.errorCode === SESSION_REPORT_TOO_MANY_ERROR_CODE
            ? SESSION_REPORT_TOO_MANY_REASON
            : '시간 초과'
        : '조회 실패';

/** 공용 오류 창 대신 처리 완료·되돌리기 버튼 옆에 보여 준다. */
export const describeResolutionError = (status?: number, code?: string): string => {
    if (status === 503) return '잠시 뒤 다시 해 주세요';
    if (status === 404) return '수강권이나 처리 기록을 찾지 못했어요. 다시 조회해 주세요.';
    if (status === 403) return '처리할 권한이 없어요. 관리자 계정을 확인해 주세요.';
    if (status === 409) {
        if (code === 'SESSION_REPORT_RESOLUTION_REQUEST_ID_REUSED') return '이미 다른 처리에 쓰인 요청이에요. 새로고침 후 다시 해 주세요.';
        if (code === 'SESSION_REPORT_RESOLUTION_BUSY') return '다른 처리와 겹쳤어요. 잠시 뒤 다시 해 주세요.';
        return '탈퇴했거나 정보가 바뀐 회원은 처리할 수 없어요. 다시 조회해 주세요.';
    }
    if (status === 400) return '처리할 정보를 확인하지 못했어요. 다시 조회해 주세요.';
    return '처리 결과를 확인하지 못했어요. 다시 시도해 주세요.';
};

/** 자동 접수의 실패는 확인 창 안에서 안내해요. 서버의 기술 문구는 그대로 노출하지 않아요. */
export const describeSupportError = (status?: number, code?: string): string => {
    if (status === 400 && code === 'SESSION_REPORT_SUPPORT_INVALID_INPUT') return '화면을 새로고침한 뒤 다시 눌러 주세요';
    if (status === 429 && code === 'SESSION_REPORT_SUPPORT_RATE_LIMITED') return '요청이 많아요. 잠시 후 다시 눌러 주세요';
    if (status === 401) return '로그인을 다시 확인한 뒤 알려 주세요.';
    if (status === 404) return '이 회원은 지금 알릴 수 없어요. 새로고침해 주세요';
    if (status === 409) {
        if (code === 'SESSION_REPORT_SUPPORT_REQUEST_ID_REUSED') return '이미 다른 접수에 쓰인 요청이에요. 다시 알리기를 눌러 주세요.';
        if (code === 'SESSION_REPORT_SUPPORT_BUSY') return '다른 접수와 겹쳤어요. 잠시 뒤 다시 해 주세요.';
        if (code === 'WITHDRAWN_MEMBER_READ_ONLY') return describeResolutionError(status, code);
        if (code === 'SESSION_REPORT_SUPPORT_NOT_REPORTABLE') return '지금은 라포에 알릴 문제가 아니에요. 숫자가 바뀌었을 수 있어요. 새로고침해 주세요.';
        return '회원 기록이나 숫자가 바뀌었을 수 있어요. 새로고침 후 다시 알려 주세요.';
    }
    if (status === 400 && code === 'SESSION_REPORT_FUTURE_MONTH') return '아직 시작하지 않은 달이에요. 조회 월을 확인해 주세요.';
    if ([400, 403, 404, 503].includes(status ?? 0)) return describeResolutionError(status, code);
    return '접수 결과를 확인하지 못했어요. 다시 알리기를 눌러 주세요.';
};
